import { createContext, useContext } from "react"

import { TableViewContextValues } from "./TableView.types"

// `any` is used here as workaround because it is not possible to create a context with a generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TableViewContext = createContext<TableViewContextValues<any> | undefined>(undefined)
TableViewContext.displayName = "TableView"

export default function useTableView<T>(): TableViewContextValues<T> {
    const context = useContext(TableViewContext)
    if (!context) {
        throw new Error("useTableView must be used within a TableView.Provider component")
    }

    return context as TableViewContextValues<T>
}
